import { render, staticRenderFns } from "./InputTag.vue?vue&type=template&id=77c5d096&scoped=true"
import script from "./InputTag.vue?vue&type=script&lang=js"
export * from "./InputTag.vue?vue&type=script&lang=js"
import style0 from "./InputTag.vue?vue&type=style&index=0&id=77c5d096&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c5d096",
  null
  
)

export default component.exports